import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {ReactNode} from 'react';

export type ColumnDef<T> = {
  key: keyof T | string;
  header: string | ReactNode;
  render?: (row: T) => ReactNode;
  align?: 'left' | 'center' | 'right';
  width?: string | number;
};

type DataTableProps<T> = {
  columns: ColumnDef<T>[];
  data: T[];
  getRowKey: (row: T, index: number) => string | number;
  elevation?: number;
  className?: string;
  containerClassName?: string;
  component?: React.ElementType;
};

function DataTable<T>({
  columns,
  data,
  getRowKey,
  elevation = 0,
  className = '',
  containerClassName = '',
  component = Paper,
}: DataTableProps<T>) {
  return (
    <TableContainer
      component={component}
      elevation={elevation}
      className={containerClassName}>
      <Table className={className}>
        <TableHead>
          <TableRow>
            {columns.map(({key, header, align, width}, idx) => (
              <TableCell
                key={`${String(key)}-${idx}`}
                align={align}
                sx={width ? {width} : undefined}>
                {typeof header === 'string' ? (
                  <strong>{header}</strong>
                ) : (
                  header
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIdx) => (
            <TableRow key={getRowKey(row, rowIdx)}>
              {columns.map(({key, render, align}, colIdx) => (
                <TableCell key={`${String(key)}-${colIdx}`} align={align}>
                  {render ? render(row) : (row[key as keyof T] as ReactNode)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DataTable;
